import { _ as __rest } from '../tslib.es6-C8rd5pYo.mjs';
import { css, jsx } from '@emotion/react';
import { Colors, Typography } from '@zapier/design-system';
import { LabelRequiredText } from './LabelRequiredText.es.js';
import { Label as Label$1 } from 'react-aria-components';

const LabelStyles = css(Object.assign(Object.assign({ display: "flex", flexDirection: "row", gap: `var(--zds-space-2, 4px)`, color: `var(--zds-text-default, ${Colors.GrayWarm9})` }, Typography.SmallPrint3), { '&[data-compact="true"]': Object.assign({}, Typography.MinimalPrint3), "&[data-state=disabled]": {
  color: `var(--zds-text-weakest, ${Colors.GrayWarm5})`,
  cursor: "not-allowed"
}, "&[data-state=invalid]": {
  color: `var(--zds-status-error-stronger, ${Colors.StatusErrorStronger})`
} }));
const AsteriskStyles = css(Object.assign(Object.assign({}, Typography.Body2Multiline), { color: `var(--zds-ui-brand, ${Colors.GrayWarm9})`, textDecoration: "none" }));
const Label = (_a) => {
  var { children, isCompact, isDisabled, isInvalid, isRequired, requiredText = "required" } = _a, props = __rest(_a, ["children", "isCompact", "isDisabled", "isInvalid", "isRequired", "requiredText"]);
  return jsx(
    Label$1,
    Object.assign({}, props, { css: LabelStyles, "data-compact": isCompact, "data-state": [isInvalid && "invalid", isDisabled && "disabled"].filter(Boolean).join(" ") || void 0, "data-zds": true }),
    children,
    isRequired && jsx("abbr", { css: AsteriskStyles, title: "required" }, "*"),
    isRequired && requiredText && jsx(LabelRequiredText, { isDisabled }, requiredText)
  );
};

export { Label };
//# sourceMappingURL=Label.es.js.map
